import { render, staticRenderFns } from "./bi-fsr-scale.vue?vue&type=template&id=5f7a9275&"
import script from "./bi-fsr-scale.vue?vue&type=script&lang=ts&"
export * from "./bi-fsr-scale.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports